function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React from "react";
import "external-svg-loader";
var isImg = function(props) {
    return !props.src.toLocaleLowerCase().endsWith("svg");
};
/**
 * INFO: careful, this makes additional GET requests to download the SVGs and render
 * them inline. This means the browser **IS NOT** able to cache them, incurring
 * additional render/load time.
 */ var UIPicture = function(props) {
    return isImg(props) ? /*#__PURE__*/ React.createElement("img", _extends({}, props, {
        alt: props.alt || "An image",
        title: props.title || "An image"
    })) : /*#__PURE__*/ React.createElement("svg", _extends({}, props, {
        "data-src": props.src
    }));
};
export default UIPicture;
